
/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {


	function inputFake(target){
		// trim polyfill : https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim
		if (!String.prototype.trim) {
			(function() {
				// Make sure we trim BOM and NBSP
				var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
				String.prototype.trim = function() {
					return this.replace(rtrim, '');
				};
			})();
		}

		[].slice.call( document.querySelectorAll( target ) ).forEach( function( inputEl ) {
			// in case the input is already filled..
			if( inputEl.value.trim() !== '' ) {
				classie.add( inputEl.parentNode.parentNode, 'input--filled' );
			}

			// events:
			inputEl.addEventListener( 'focus', onInputFocus );
			inputEl.addEventListener( 'blur', onInputBlur );
		} );
	}

	function onInputFocus( ev ) {
		classie.add( ev.target.parentNode.parentNode, 'input--filled' );
	}

	function onInputBlur( ev ) {
		if( ev.target.value.trim() === '' ) {
			classie.remove( ev.target.parentNode.parentNode, 'input--filled' );
		}
	}

	jQuery(function ($) {
		$.fn.fakeCheckbox = function (settings) {
			var defaults = {
				button_type: 'checkbox',
			};

			var options = $.extend(defaults, settings);

			return this.each(function() {
				var $element = $(this),
				$label = $element.find('label').text(),
				$fakeCheckboxWrapper = $('<li><span class="fake-checkbox"></span><span class="fake-label">'+$label+'</span></li>');

				$element.hide().before($fakeCheckboxWrapper).siblings($('.fake-checkbox')).click(function() {

					if(options.button_type == 'radio'){
						$element.each(function(){
							$(this).parent('ul').find('li').removeClass('checked');
						});
					}

					var $fakeCheckboxWrapper = $(this),
					$checkbox = $fakeCheckboxWrapper.next($element).find('input[type='+options.button_type+']');

					$fakeCheckboxWrapper.toggleClass('checked');

					if(options.button_type == 'radio'){
						$checkbox.prop("checked", true);
					}else{
						$checkbox.prop("checked", !$checkbox.prop("checked"));
					}
				});
			});
		};
	});

  var Fn = {
    initDefaultSwiper : function(){
      var $slider = [];
      $('.swiper-container-default').each(function(index){

        $slider[index] = new Swiper($(this), {
          speed : 800,
          navigation: {
            nextEl : '.swiper-button-next',
            prevEl : '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'bullets'
          },
          effect: 'fade',
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false
          }
        });

        $( window ).resize(function() {
	    		setTimeout(function(){
	    			$slider[index].update(true);
	    		}, 400);
	    	});

      });
    },
    initRangeWineSlider : function(){
      $('.range-wines').each(function(index){
        var _this = $(this),
        container = _this.find('.swiper-container'),
        nextEl = _this.find('.swiper-button-next'),
        prevEl = _this.find('.swiper-button-prev'),
        $slider = [];

        $slider[index] = new Swiper(container, {
          speed : 800,
          navigation: {
            nextEl : nextEl,
            prevEl : prevEl
          },
          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 20
            },
            992: {
              slidesPerView: 3,
              spaceBetween: 30
            }
          }
        });

        $( window ).resize(function() {
	    		setTimeout(function(){
	    			$slider[index].update(true);
	    		}, 400);
	    	});

      });
    },
    initMomentSlider : function(){
      var mySwiper = new Swiper ('.moments .swiper-container',{
        speed : 800,
        watchOverflow: true,
				slidesPerView: 3,
				slidesPerGroup: 3,
				spaceBetween: 30,
        // centeredSlides: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        },
        breakpoints: {
          320: {
            slidesPerView: 1.1,
            spaceBetween: 20,
						slidesPerGroup: 1
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
						slidesPerGroup: 2
          },
          992: {
            slidesPerView: 3,
            slidesPerGroup: 3
          }
        }
      });
      // mySwiper.slideTo(1);
    },
    initMostReadSlider : function(){
			// https://medium.com/@networkaaron/swiper-how-to-destroy-swiper-on-min-width-breakpoints-a947491ddec8
			var breakpoint = window.matchMedia( '(min-width:62em)' ); //992px

			  // keep track of swiper instances to destroy later
			  var mySwiper,
				breakpointChecker = function() {

		    // if larger viewport and multi-row layout needed
		    if ( breakpoint.matches === true ) {
			      // clean up old instances and inline styles when available
				  if ( mySwiper !== undefined ) mySwiper.destroy( true, true );
				  	// or/and do nothing
				  	return;
		      	// else if a small viewport and single column layout needed
		      } else if ( breakpoint.matches === false ) {
		        // fire small viewport version of swiper
		        return enableSwiper();
		      }
			  };
			  var enableSwiper = function() {

					mySwiper = new Swiper ('.to-swiper',{
		        speed : 800,
		        watchOverflow: true,
						slidesPerView: 1.3,
						spaceBetween: 20,
						pagination: {
		          el: '.swiper-pagination',
		          type: 'bullets',
		          clickable: true
		        },
						breakpoints: {
	            320: {
	              slidesPerView: 1.3,
	              spaceBetween: 20,
	            },
	            640: {
	              slidesPerView: 2,
	            }
	          }
		      });
			  };

			  // keep an eye on viewport size changes
			  breakpoint.addListener(breakpointChecker);

			  breakpointChecker();
    },
    asyncFonts : function(){
      window.WebFontConfig = {
        typekit: { id: 'xtb6qfj' }
      };

      (function(d) {
        var wf = d.createElement('script'), s = d.scripts[0];
        wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js';
        wf.async = true;
        s.parentNode.insertBefore(wf, s);
      })(document);
    },
		fakeShare : function(){
			$('.social-link').click(function(e){
				e.preventDefault();
				var $link   = $(this);
				var href    = $link.attr('href');
				var network = $link.attr('data-network');

				var networks = {
					facebook : { width : 600, height : 300 },
					twitter  : { width : 600, height : 254 },
					google   : { width : 515, height : 490 },
					linkedin : { width : 600, height : 473 },
					pinterest : { width : 600, height : 600 }
				};

				var x = screen.width/2 - networks[network].width/2;
				var y = (screen.height/2 - networks[network].height/2)-200;

				var popup = function(network){
					var options = 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,';
					window.open(href, '', options+'height='+networks[network].height+',width='+networks[network].width+',left='+x+',top='+y);
				};

				popup(network);
			});
		},
    hoverCard : function(){
      // $('.read-more, .read-more-wine-wrapper a, .btn-find-it').hover(
      $('.card-blog a').hover(
        function() {
          var _this = $(this),
          card = _this.parents('.card-blog');
          if(card.length){
            var color = card.data('color');
            card.addClass('active card-blog-'+color);
          }
        }, function() {
          var _this = $(this),
          card = _this.parents('.card-blog');
          if(card.length){
            var color = card.data('color');
            card.removeClass('active card-blog-'+color);
          }
        }
      );
      $('.read-more-most').hover(
        function() {
          var _this = $(this),
          card = _this.parents('.most-readed');
          if(card.length){
            var color = card.data('color');
            card.addClass('most-readed-'+color);
          }
        }, function() {
          var _this = $(this),
          card = _this.parents('.most-readed');
          if(card.length){
            var color = card.data('color');
            card.removeClass('most-readed-'+color);
          }
        }
      );
    },
		fixedFilters : function(){
			var fFilters = $('.range-selector-wrapper'),
			distance = fFilters.offset().top,
			body = $('body'),
			listing = $('.listing'),
			filterHeight = fFilters.outerHeight()+40;

			$(window).scroll(function() {
				if ( $(this).scrollTop()+$('.main_wrapper .header').outerHeight()+20 >= distance ) {
					body.addClass('locked-filters');
					if ($(window).width() >= 992){
						listing.css( 'padding-top', filterHeight+'px' );
					}
				} else {
					body.removeClass('locked-filters');
					listing.removeAttr('style');
				}
			});
		},
		viewTasting : function(){
			var relation = $('.product-relation');
			relation.each(function(){
				var _this = $(this),
				btn = _this.find('.btn-discover');

				btn.click(function(e){
					e.preventDefault();
					_this.toggleClass('visible');
				});
			});
		},
    searchShop : function(){
      $(document).on( 'submit', '#product-search', function(e) {
        e.preventDefault();
          var $form = $(this),
            $input = $form.find('input[name="s"]'),
            query = $input.val(),
            results = $('#search-results'),
						loader = $form.find('.spinner-border'),
						svg = $form.find('svg'),
						cancel = $form.find('.cancel');

				cancel.click(function(e){
					$input.val('');
				});


        if(query){
            $.ajax({
                type : 'post',
                url : myAjax.ajaxurl,
                data : {
                  action : 'load_product_search_results',
                  query : query
                },
                beforeSend: function() {
                  svg.hide();
                  loader.show();
                },
                success : function( response ) {
                  if(response.length){
                    results.html(response);
										svg.show();
	                  loader.hide();
                  }
                }
            });
        }

          return false;
      });
    },
    searchCityShop : function(){
      $(document).on( 'submit', '#city-search', function(e) {
        e.preventDefault();
          var $form = $(this),
            $input = $form.find('input[name="s"]'),
            query = $input.val(),
            results = $('#search-results'),
						loader = $form.find('.spinner-border'),
						svg = $form.find('svg'),
						cancel = $form.find('.cancel'),
						idprod = $('#idprod').val();

				cancel.click(function(e){
					$input.val('');
				});

        if(query){
            $.ajax({
                type : 'post',
                url : myAjax.ajaxurl,
                data : {
                  action : 'load_city_product_search_results',
                  query : query,
									idprod : idprod
                },
                beforeSend: function() {
									svg.hide();
                  loader.show();
                },
                success : function( response ) {
                  if(response.length){
                    results.html(response);
										svg.show();
	                  loader.hide();
                  }
                }
            });
        }

          return false;
      });
    },
		smoothScroll : function(){
			var x = location.hash;
			if(x){
				x.replace(/^\//,"");
				$("html, body").animate( { scrollTop: $(x).offset().top-$('header.header').outerHeight()+100 }, 1800);
			}
		}
  };

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        // Handle menu
				var navButton = $('.header .nav_button'),
				html = $('html'),
				nav = $('.nav-menu');

				navButton.click(function(){
					if(html.hasClass('nav_active') || html.hasClass('nav_inactive')){
						html.toggleClass('nav_active').toggleClass('nav_inactive');
					}else{
						html.addClass('nav_active');
						if($(window).width() <= 480){
							$('html, body').animate({
								scrollTop: $('html').offset().top
							}, 1500);
						}
					}
				});

				// Close menu
				$('.nav-menu .close').click(function(){
					html.toggleClass('nav_active');
					$(this).parent().find('li').each(function(){
						$(this).removeClass('active').find('.sub-menu').hide();
					});
				});

				// Handle search overlay
				var searchButton = $('.header .nav_button_container .search'),
				overlay = $('#search_overlay'),
				closeOverlay = overlay.find('.close'),
				body = $('body');

				searchButton.click(function(){
					overlay.fadeIn();
					body.addClass('ov_hidden');
				});

				closeOverlay.click(function(){
					overlay.fadeOut('fast');
					body.removeClass('ov_hidden');
					$('#producta_search_result').html('');
					$('#producta_search input[name="s"]').val('');
				});

				// Handle Newsletter overlay
				var overlayNews = $('#subscribe-to-newsletter'),
				closeOverlayNews = overlayNews.find('.close');

				$('#newsletter-subscribe').click(function(e){
					e.preventDefault();
					overlayNews.fadeIn();
					body.addClass('ov_hidden');
				});

				closeOverlayNews.click(function(){
					overlayNews.fadeOut('fast');
					body.removeClass('ov_hidden');
				});


				// Menu on click
				$('nav ul li, .footer-resp-nav ul li').not('nav ul li ul li, .footer-resp-nav ul li ul li').click(function(){
					var acc_this = $(this),
					accordion = acc_this.find('.sub-menu');
					acc_this.addClass('active').find('ul.sub-menu').slideDown();
					$('nav ul li ul, .footer-resp-nav ul li ul').not(accordion).slideUp('fast').parent().removeClass('active');
				});

				// Back to top
				$('.footer #top').click(function(e){
					e.preventDefault();
					$('html, body').animate({
						scrollTop: $('html').offset().top
					}, 1500);
				});

				// handle responsive
				// cbp-af-header-shrink
				if ( $(window).width() <= 960){
					$('.cbp-af-header').addClass('cbp-af-header-shrink');
				}
      },
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        Fn.initDefaultSwiper();
      }
    },
    // Contact
    'page_template_template_contact': {
      init: function() {
        // JavaScript to be fired on the home page
				$("#gform_fields_1 #field_1_5 select option:first,#gform_fields_1 #field_1_6 select option:first").attr('selected','selected').attr('disabled','disabled');
				inputFake('.ginput_container input.large, .ginput_container input.medium, .ginput_container textarea.textarea');
				setTimeout(function(){
					[].slice.call( document.querySelectorAll( '.cs-select select' ) ).forEach( function(el) {
						new SelectFx(el);
					} );
				}, 400);
      }
    },
    //
    'page_template_creations': {
      init: function() {
        Fn.initDefaultSwiper();
      }
    },
    'page_template_nos_chateaux': {
      init: function() {
        Fn.initDefaultSwiper();
        Fn.initRangeWineSlider();
      }
    },
    'single_who': {
      init: function() {
        Fn.initDefaultSwiper();
      }
    },
    'page_template_template_blog': {
      init: function() {
        Fn.asyncFonts();
        Fn.initMomentSlider();
        Fn.hoverCard();
				Fn.initMostReadSlider();
				Fn.fakeShare();
				if ($(window).width() > 768){
	        Fn.fixedFilters();
	      }

				$(window).resize(function(){
	        Fn.fixedFilters();
	      });
      }
    },
    'single_blog': {
      init: function() {
        Fn.asyncFonts();
				Fn.viewTasting();
				Fn.hoverCard();
				Fn.fakeShare();
				Fn.initMomentSlider();
			}
		},
    'single_wine_rayon': {
      init: function() {
        Fn.asyncFonts();
				Fn.initMomentSlider();
				Fn.hoverCard();
			}
		},
    'page_template_template_rayon': {
      init: function() {
        Fn.asyncFonts();
        Fn.initMomentSlider();
        Fn.hoverCard();
        Fn.initMostReadSlider();
				Fn.smoothScroll();
        if ($(window).width() > 768){
          Fn.fixedFilters();
        }

        $(window).resize(function(){
          Fn.fixedFilters();
        });
      }
    },
    'tax_cat_blog': {
      init: function() {
        Fn.asyncFonts();
        Fn.initMomentSlider();
        Fn.hoverCard();
        Fn.initMostReadSlider();
				Fn.fakeShare();
				Fn.smoothScroll();
        if ($(window).width() > 768){
          Fn.fixedFilters();
        }

        $(window).resize(function(){
          Fn.fixedFilters();
        });



      }
    },
    'page_template_template_magasin': {
      init: function() {
				Fn.asyncFonts();
        Fn.searchShop();
        Fn.searchCityShop();
				Fn.initMomentSlider();
				Fn.hoverCard();
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
